module.exports = __webpack_public_path__ + "static/img/2.1.4609efb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/eng/2.1.png
// module id = jHj7
// module chunks = 0